import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";

export interface SupportTicketQueryScope {
  accountId?: string | null;
  teamId?: string | null;
}

export type SupportTicketQueryScopeKey =
  | readonly ["account", string]
  | readonly ["team", string]
  | readonly ["unscoped"];

export function supportTicketQueryScopeKey(
  scope?: SupportTicketQueryScope,
): SupportTicketQueryScopeKey {
  const accountId = scope?.accountId?.trim();
  if (accountId) {
    return ["account", accountId];
  }

  const teamId = scope?.teamId?.trim();
  if (teamId) {
    return ["team", teamId];
  }

  return ["unscoped"];
}

export const supportTicketCountsQueryKey = ["supportTicketCounts"] as const;

export function supportTicketCountsScopedQueryKey(
  scope?: SupportTicketQueryScope,
) {
  return [...supportTicketCountsQueryKey, ...supportTicketQueryScopeKey(scope)];
}

export const activeViewStatusCountsBaseQueryKey = [
  "activeViewStatusCounts",
] as const;

export function activeViewStatusCountsQueryKey(
  encodedFilterGroupKey: string,
  scope?: SupportTicketQueryScope,
) {
  return [
    ...activeViewStatusCountsBaseQueryKey,
    ...supportTicketQueryScopeKey(scope),
    encodedFilterGroupKey,
  ] as const;
}

export const supportTicketsPageBaseQueryKey = ["support-tickets-page"] as const;

export function supportTicketsPageScopedQueryKey(
  scope?: SupportTicketQueryScope,
) {
  return [
    ...supportTicketsPageBaseQueryKey,
    ...supportTicketQueryScopeKey(scope),
  ] as const;
}

export function supportTicketsPageQueryKey(
  page: number,
  encodedFilterGroup: string | undefined,
  scope?: SupportTicketQueryScope,
) {
  return [
    ...supportTicketsPageScopedQueryKey(scope),
    page,
    encodedFilterGroup,
  ] as const;
}

export function supportTicketDetailQueryKey(
  supportTicketId: SupportTicketId,
  scope?: SupportTicketQueryScope,
) {
  return [
    "support-ticket",
    ...supportTicketQueryScopeKey(scope),
    supportTicketId,
  ] as const;
}

export const supportTicketDraftQueryKeys = { all: ["drafts"] as const };
